const GoodsOrderVerify = () => import('@/views/Order/goods-order-verify.vue')
const OilOrder = () => import('@/views/Order/oil-order.vue')
const GoodsOrder = () => import('@/views/Order/goods-order.vue')
const Recharge = () => import('@/views/Order/recharge.vue')

const router = [
  {
    meta: {title: '核销记录', route: 'goods_order_verify_index'},
    path: 'goods-order-verify',
    name: 'goods-order-verify',
    component: GoodsOrderVerify
  },
  {
    meta: {title: '加油订单', route: 'oil_order_index'},
    path: 'oil-order',
    name: 'oil-order',
    component: OilOrder
  },
  {
    meta: {title: '商城订单', route: 'goods_order_index'},
    path: 'goods-order',
    name: 'goods-order',
    component: GoodsOrder
  },
  {
    meta: {title: '充值订单', route: 'recharge_index'},
    path: 'recharge',
    name: 'recharge',
    component: Recharge
  }
]
module.exports = {router};
